import React, { useState, useEffect } from 'react'
import { Table, Modal, message, Button, Popconfirm } from "antd";
import { PlusOutlined } from '@ant-design/icons';
import InspectionApi from '@api/inspectionnew'
import HandleButton from '@components/HandleButton'
import { connect } from 'react-redux'
import moment from 'moment';
import AddModel from './add'
import { toolMouseTip } from '@utils/common'
import '../style.scss'

const OrderCom = (props) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [editVisible, setEditVisible] = useState(false)
  const [editTitle, setEditTitle] = useState('新增缺陷等级')
  const [rowParams, setRowParams] = useState()
  const [detailVisible, setDetailVisible] = useState(false)
  const [detail, setDetail] = useState({})
  // 搜索相关参数
  const [searchParams, setSearchParams] = useState({
    pageNum: 1,
    pageSize: 10,
    name: ''
  })
  const [total, setTotal] = useState(0)
  const [btnList, setBtnList] = useState([
    {
      title: "新增",
      type: 'primary',
      icon: <PlusOutlined />,
      visible: props.userInfo.btnResources.indexOf('defect:level:add') === -1 ? false : true,
      onClick: () => {
        setRowParams(null)
        setEditVisible(true)
      }
    }
  ])

  useEffect(() => {
    listByRole()
    return () => { }
  }, [searchParams])

  const listByRole = () => {
    setLoading(true)
    InspectionApi.defectLevel({ ...searchParams, status: searchParams.status * 1 }).then(res => {
      setLoading(false)
      if (res.status == 0 && res.data) {
        setData(res.data.data || [])
        setTotal(res.data.total)
      }
    })
  }

  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    setSearchParams(params)
  };

  // 删除
  const handleConfirm = (info) => {
    InspectionApi.defectLevelDel({ id: info.id }).then(res => {
      if (res.status == '0') {
        message.success('删除成功')
        listByRole()
      }
    })
  }

  // 编辑
  const showEditModal = (info) => {
    const { id } = info
    InspectionApi.defectLevelGetInfo({ id }).then(res => {
      if (res.status !== '0') return
      setRowParams({
        defectLevelName: res.data.defectLevelName,
        recOperate: res.data.recOperate,
        remark: res.data.remark,
        deptIds: res.data.deptIds,
        id
      })
      setEditTitle('编辑缺陷等级')
      setEditVisible(true)
    })
  }

  const showDetail = (record) => {
    setDetail(record)
    setDetailVisible(true)
  }
  const columns = [
    {
      width: 120,
      title: '缺陷等级名称',
      dataIndex: 'defectLevelName',
      align: 'center',
      key: 'defectLevelName',
    },
    {
      title: '建议操作',
      dataIndex: 'recOperate',
      align: 'center',
      key: 'recOperate',
      ellipsis: true
    },
    {
      title: '缺陷等级说明',
      dataIndex: 'remark',
      align: 'center',
      key: 'remark',
      ellipsis: true
    },
    {
      title: '通知部门',
      dataIndex: 'notifierDeptNames',
      align: 'center',
      key: 'notifierDeptNames',
      render: _t => toolMouseTip(_t, 15)
    },
    {
      title: '创建时间',
      dataIndex: 'createAt',
      align: 'center',
      key: 'createAt',
      width: 200,
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },
    {
      title: '修改时间',
      dataIndex: 'updateAt',
      align: 'center',
      key: 'updateAt',
      width: 200,
      render: (obj) => {
        if (obj) {
          return (
            moment(obj).format('YYYY-MM-DD HH:mm:ss')
          )
        }
      }
    },

    {
      title: '操作',
      key: 'operation',
      align: 'center',
      width: '200px',
      fixed: 'right',
      render: (obj, record) => {
        return (
          <>
            { 
              props.userInfo.btnResources.indexOf('defect:level:edit') !== -1 && 
              <Button className='worningBtn' onClick={() => showEditModal(record)} size='small' type="primary" style={{ marginRight: 10 }}>编辑</Button>
            }
            <Popconfirm
              title={`确定要删除该缺陷等级吗`}
              onConfirm={() => handleConfirm(record)}
              okText="确定"
              cancelText="取消"
            >
              {
                props.userInfo.btnResources.indexOf('defect:level:delete') !== -1 &&
                <Button className='deleteBtn' size='small' type="primary">删除</Button>
              }
            </Popconfirm>
            {
              props.userInfo.btnResources.indexOf('defect:level:info') !== -1 &&
              <Button style={{ marginLeft: 10 }} onClick={() => showDetail(record)} size='small' type="primary">详情</Button>
            }
          </>
        )
      }
    }
  ]
  return (
    <div className='baseContent boundary'>
      <div className='title'>
        <HandleButton btnList={btnList} btnStyle={{ padding: '0 24px 20px', textAlign: 'right' }} />
        <div >
          <Table
            className='Table'
            scroll={{ x: columns.length * 200 }}
            columns={columns}
            dataSource={data}
            rowKey={record => record.id}
            pagination={{
              current: searchParams.pageNum,
              pageSize: searchParams.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
        {editVisible && <AddModel visible={editVisible} title={editTitle} formData={rowParams} cancel={(bool) => { setEditVisible(false); bool && listByRole() }} />}
        <Modal
          title="缺陷等级详情"
          open={detailVisible}
          onCancel={() => setDetailVisible(false)}
          onOk={() => setDetailVisible(false)}
        >
          <div className='defects-level-c'>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>缺陷等级名称:</div>
              <div className='defects-level-item-content'>{detail.defectLevelName}</div>
            </div>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>建议操作:</div>
              <div className='defects-level-item-content'>{detail.recOperate}</div>
            </div>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>缺陷等级说明:</div>
              <div className='defects-level-item-content'>{detail.remark}</div>
            </div>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>通知部门:</div>
              <div className='defects-level-item-content'>{detail.notifierDeptNames}</div>
            </div>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>创建时间:</div>
              <div className='defects-level-item-content'>{moment(detail.createAt).format('YYYY-MM-DD HH:mm:ss')}</div>
            </div>
            <div className='defects-level-item'>
              <div className='defects-level-item-label'>修改时间:</div>
              <div className='defects-level-item-content'>{moment(detail.updateAt).format('YYYY-MM-DD HH:mm:ss')}</div>
            </div>
          </div>
        </Modal>
      </div>
    </div >
  )
}

const mapStateToProps = state => {
  return {
    ...state.Common
  }
};

export default connect(mapStateToProps)(OrderCom)
